import { WorkerRequirementMappingLevel } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";
import { isBefore, parseISO } from "date-fns";
import { intersection, isEmpty } from "lodash";

interface FilterBlockingRequirementsForShiftProps {
  workplace: {
    id: string;
    workplaceType?: string;
    msa?: string;
    state?: string;
    region?: string; // also known as county
  };
  qualifications: string[];
  workplaceRequirements?: WorkerRequirement[];
  expiryDate: string;
}

export function filterBlockingRequirementsForShift(props: FilterBlockingRequirementsForShiftProps) {
  const { workplace, qualifications, workplaceRequirements, expiryDate } = props;
  const { id: workplaceId, workplaceType, msa, state, region } = workplace;

  return workplaceRequirements?.filter((requirement) => {
    const isRequirementApplicableForShift = requirement.requirementMappings?.some((mapping) => {
      const matchingWorkplaceTypes =
        isEmpty(mapping.attributes.workplaceTypes) ||
        (isDefined(workplaceType) && mapping.attributes.workplaceTypes.includes(workplaceType));

      const matchingQualifications = !isEmpty(
        intersection(mapping.attributes.qualifications, qualifications)
      );

      const matchingLevel =
        mapping.attributes.level === WorkerRequirementMappingLevel.GLOBAL ||
        (mapping.attributes.level === WorkerRequirementMappingLevel.HCF &&
          mapping.attributes.requiredBy.includes(workplaceId)) ||
        (isDefined(msa) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.MSA &&
          mapping.attributes.requiredBy.includes(msa)) ||
        (isDefined(state) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.STATE &&
          mapping.attributes.requiredBy.includes(state)) ||
        (isDefined(region) &&
          mapping.attributes.level === WorkerRequirementMappingLevel.COUNTY &&
          mapping.attributes.requiredBy.includes(region));

      return matchingWorkplaceTypes && matchingQualifications && matchingLevel;
    });

    if (!isRequirementApplicableForShift) {
      return false;
    }

    if (!requirement.isValid) {
      return true;
    }

    return (
      isDefined(requirement.expiry) && isBefore(parseISO(requirement.expiry), parseISO(expiryDate))
    );
  });
}
